import React, { useState, useEffect } from 'react';
import Robotic from '../assets/sliderImages/BannerRobotic.webp';
import RoboticSuregry from '../assets/sliderImages/RoboticSurgery.jpg';
import MSC from '../assets/sliderImages/MultiSpecialityCare.jpg';
import CS from '../assets/sliderImages/CardioSciences.jpg';
import S1 from '../assets/sliderImages/Sliders 1.png';
import S2 from '../assets/sliderImages/Sliders 2.png';
import S3 from '../assets/sliderImages/Sliders 3.png';
import S4 from '../assets/sliderImages/Sliders 4.png';
import S5 from '../assets/sliderImages/Sliders 5.png';
import S6 from '../assets/sliderImages/Sliders 6.png';

const BannerSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Corrected image array with paths
  const images = [RoboticSuregry, Robotic, CS, MSC, S1, S2, S3, S4, S5, S6];

  // Handler to switch the active image
  const handleCircleClick = (index) => {
    setActiveIndex(index);
  };

  // Auto-switch functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Switch every 4 seconds

    // Clear interval when the component unmounts or user clicks on navigation
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="relative w-full">
      {/* Banner Images */}
      <div className="w-full overflow-hidden relative">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <div key={index} className="w-full h-[400px] flex-shrink-0">
              <img
                src={image}
                alt={`Banner ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Circles */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-4">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => handleCircleClick(index)}
            className={`w-3 h-3 rounded-full border-2 transition-all duration-300 ${
              activeIndex === index
                ? 'bg-blue-500 border-blue-500'
                : 'bg-white border-white hover:bg-gray-300'
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default BannerSlider;
